import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  OverlayTrigger,
  Tooltip,
  Button,
} from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import { IoIosArrowUp } from "react-icons/io";
import resetBtn from "../../assets/images/reset-arrow.svg";
import downloadBtn from "../../assets/images/filter-download-btn.svg";
import DataTable, { createTheme } from "react-data-table-component";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import {
  getAllSiteSettings,
  deleteSiteSettings,
} from "../../actions/siteSettings";
import { toast } from "react-toastify";
import SweetAlert from "react-bootstrap-sweetalert";
import { useSelector } from "react-redux";
import InitializeLocalStorage from "../../components/PaginationHandle";

createTheme(
  "solarized",
  {
    text: {
      primary: "#000",
      secondary: "#000",
    },
    background: {
      default: "#fff",
    },
    context: {
      background: "#cb4b16",
      text: "#FFFFFF",
    },
    divider: {
      default: "#DFE0EB",
    },
    action: {
      button: "rgba(0,0,0,.54)",
      hover: "rgba(0,0,0,.08)",
      disabled: "rgba(0,0,0,.12)",
    },
  },
  "dark"
);

const Index = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [getDelete, setDelete] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const [filterText, setFilterText] = useState("");
  const [selectedOption, setSelectedOption] = useState();
  const [filteredItems, setFilteredItems] = useState([]);
  const [isFilterOpen, setIsFilterOpen] = useState(true);
  const { admin } = useSelector((state) => state.admin);
  const currentUserRole = admin.role;

  const location = useLocation();
  const { pathname } = location;

  InitializeLocalStorage(pathname, localStorage.getItem("currentURL"));

  const getAll = async () => {
    setLoader(true);
    let res = await getAllSiteSettings();
    if (res?.data) {
      setData(res?.data?.siteSettings);
    }
    setLoader(false);
  };
  const hideModel = () => {
    setDelete(false);
  };

  const showModel = (id) => {
    setDeleteId(id);
    setDelete(true);
  };

  useEffect(() => {
    getAll();
  }, []);

  const caseInsensitiveSort = (rowA, rowB, columnId) => {
    const getProperty = (row, columnId) => {
      switch (columnId) {
        case "Attribute":
          return row?.attributeName || "";

        case "Attribute Value":
          return row?.attributeValue || "";
        case "Status":
          return row?.isCritical || "";

        default:
          return "";
      }
    };

    const a = getProperty(rowA, columnId);
    const b = getProperty(rowB, columnId);

    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }
    return 0;
  };

  const deleteSettings = async () => {
    setDelete(false);
    setLoader(true);
    let res = await deleteSiteSettings(deleteId);
    if (res?.data?.success) {
      toast.success(res.data.message);
      getAll();
    }
    setLoader(false);
  };

  const columns = [
    {
      name: "Attribute",
      selector: (row) => row?.attributeName,
      sortable: true,
      sortFunction: (a, b) => caseInsensitiveSort(a, b, "Attribute"),
    },
    {
      name: "Attribute Value",
      selector: (row) => row?.attributeValue,
      sortable: true,
      sortFunction: (a, b) => caseInsensitiveSort(a, b, "Attribute Value"),
    },
    {
      name: "Status",
      selector: (row) => (
        <>
          {row.status ? (
            <label className="label label-success m-0">Active</label>
          ) : (
            <label className="label label-danger m-0">Inactive</label>
          )}
        </>
      ),
      sortable: true,
      sortFunction: (a, b) => caseInsensitiveSort(a, b, "Status"),
    },
    {
      name: "Actions",
      selector: (row) => (
        <>
          <div className="td-actions table-actions-btns">
            <ul className="list-unstyled mb-0 d-flex justify-content-center">
              {currentUserRole?.editSetting ? (
                <li className="d-inline-block align-top">
                  <OverlayTrigger
                    overlay={<Tooltip id="tooltip-436082023">Edit</Tooltip>}
                    placement="left"
                  >
                    <Link
                      to={`/site-settings/edit/${row._id}`}
                      type="button"
                      className="btn-link btn-icon btn btn-success"
                    >
                      <FaEdit />
                    </Link>
                  </OverlayTrigger>
                </li>
              ) : (
                <li className="d-inline-block align-top">
                  <OverlayTrigger
                    overlay={<Tooltip id="tooltip-436082023">Edit</Tooltip>}
                    placement="left"
                  >
                    <Link
                      to={""}
                      type="button"
                      disabled
                      className="btn-link btn-icon btn btn-success disabled"
                    >
                      <FaEdit />
                    </Link>
                  </OverlayTrigger>
                </li>
              )}
              {currentUserRole?.deleteSetting ? (
                <li className="d-inline-block align-top">
                  <OverlayTrigger
                    overlay={<Tooltip id="tooltip-436082023">Delete</Tooltip>}
                    placement="left"
                  >
                    <button
                      onClick={() => showModel(row._id)}
                      type="button"
                      className="btn-link btn-icon btn btn-danger"
                    >
                      <FaTrash />
                    </button>
                  </OverlayTrigger>
                </li>
              ) : (
                <li className="d-inline-block align-top">
                  <OverlayTrigger
                    overlay={<Tooltip id="tooltip-436082023">Delete</Tooltip>}
                    placement="left"
                  >
                    <button
                      type="button"
                      disabled
                      className="btn-link btn-icon btn btn-danger disabled"
                    >
                      <FaTrash />
                    </button>
                  </OverlayTrigger>
                </li>
              )}
            </ul>
          </div>
        </>
      ),
      sortable: false,
    },
  ];

  const filterDatatable = (text) => {
    setFilterText(text);
    filterSearchDatatable(selectedOption, text);
  };

  const filterSearchDatatable = (text, searchText) => {
    const filteredItemsResult = data.filter((data) => {
      if (text) {
        if (
          data.status.toString().toLowerCase().includes(text.toLowerCase()) &&
          (data?.attributeName
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
            data?.attributeValue
              .toLowerCase()
              .includes(searchText.toLowerCase()))
        ) {
          return data;
        }
      } else if (
        data?.attributeName.toLowerCase().includes(searchText.toLowerCase()) ||
        data?.attributeValue.toLowerCase().includes(searchText.toLowerCase())
      ) {
        return data;
      }
      return undefined;
    });
    setFilteredItems([...filteredItemsResult]);
    setSelectedOption(text);
  };

  const resetFilter = () => {
    setFilterText("");
    setFilteredItems([...data]);
    setSelectedOption("");
  };

  const toggleFilterAccordion = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  useEffect(() => {
    if (data) {
      setFilteredItems([...data]);
    }
  }, [data]);

  return (
    <>
      {getDelete ? (
        <SweetAlert
          warning
          showCloseButton
          showCancel
          confirmBtnText="Yes"
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="light"
          title="Are you sure you want to delete?"
          onConfirm={deleteSettings}
          onCancel={hideModel}
          focusCancelBtn
          customClass="del-sweet-alert"
        >
          You will not be able to recover this data!
        </SweetAlert>
      ) : null}
      {loader ? (
        <FullPageLoader />
      ) : (
        <div className="pt-2 pt-md-3 site-setting-tablz">
          <Container fluid>
            <Row>
              <Col md="12">
                <Card className="filter-card card">
                  <Card.Header 
                    style={{ cursor: "pointer" }}
                    onClick={toggleFilterAccordion}
                  >
                    <div className="d-flex align-items-center justify-content-between table-head">
                      <Card.Title className="text-white" as="h4">
                        Filter
                      </Card.Title>
                      <div 
                        style={{ 
                          transform: isFilterOpen ? "rotate(0deg)" : "rotate(180deg)",
                          transition: "transform 0.3s ease"
                        }}
                      >
                        <IoIosArrowUp />
                      </div>
                    </div>
                     
                  </Card.Header>
                  {isFilterOpen && (
                  <Card.Body>
                    <Row>
                      <Col xl={4} sm={6} className="search-wrap">
                        <Form.Group>
                          <Form.Label className="d-block mb-2 text-white">
                            Search with title...
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="search"
                            placeholder="Search"
                            value={filterText}
                            onChange={(e) => filterDatatable(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col xl={4} sm={6} className="search-wrap">
                        <Form.Group>
                          <Form.Label className="d-block mb-2 text-white">
                            Filter with status...
                          </Form.Label>
                          <select
                            value={selectedOption}
                            onChange={(e) =>
                              filterSearchDatatable(e.target.value, filterText)
                            }
                          >
                            <option value="">Select Status</option>
                            <option value="true">Active</option>
                            <option value="false">Inactive</option>
                          </select>
                        </Form.Group>
                      </Col>
                      <Col xl={4} md={6}>
                        <Form.Group>
                          <label className="d-none d-sm-block mb-2 form-label">
                            &nbsp;
                          </label>
                          <div className="d-flex  filter-btns-holder">
                            <button
                              type="button"
                              className="outline-button filter-reset-btn"
                              onClick={() => resetFilter()}
                            >
                              <img src={resetBtn} className="img-fluid mr-3" alt="logo"/>
                              Reset
                            </button>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                  )}
                </Card>

                <div className="datatable-title card d-flex flex-row justify-content-between align-items-center mb-0">
                  <h4 className="card-title">Site Settings Listing</h4>
                  {currentUserRole?.addSetting ? (
                    <div className="btn-add">
                      <Link
                        className="float-sm-right btn-filled d-flex align-items-center"
                        to="/site-settings/add"
                      >
                        <span className="add-icon mr-2">
                          <FaPlus />
                        </span>{" "}
                        Add Site Settings
                      </Link>
                    </div>
                  ) : (
                    <div className="btn-add">
                      <Button
                        className="float-sm-right btn-filled d-flex align-items-center disabled"
                        disabled
                      >
                        <span className="add-icon mr-2">
                          <FaPlus />
                        </span>{" "}
                        Add Site Settings
                      </Button>
                    </div>
                  )}
                </div>
                  <div className="custom-datatable-pagination">
                <DataTable
                  columns={columns}
                  data={filteredItems}
                  theme="solarized"
                  pagination
                  className="react-datatable"
                />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </>
  );
};

export default Index;
